<template>
  <v-col cols="auto">
    <v-row class="title">
      <v-col v-if="icon" class="px-0" cols="auto">
        <v-icon>mdi-{{ titleIcon }}</v-icon>
      </v-col>
      <v-col cols="auto" v-if="editable && edit">
        <v-text-field v-model="text" :placeholder="empty" dense hide-details>
        </v-text-field>
      </v-col>
      <v-col cols="auto" v-else>
        <h4 class="title text-center text-capitalize" @dblclick="toggleEdit">
          {{ text || empty }}
        </h4>
      </v-col>
      <v-col cols="auto" v-if="editable">
        <v-icon v-if="edit" :disabled="!text" @click="toggleEdit">
          mdi-content-save
        </v-icon>
        <v-icon v-else class="edit" @click="toggleEdit">mdi-pencil</v-icon>
      </v-col>
    </v-row>
  </v-col>
</template>

<script lang="ts">
import Vue from "vue";
import VueTypes from "vue-types";

export default Vue.extend({
  name: "TitleComp",
  data() {
    return {
      edit: false,
    };
  },
  props: {
    value: VueTypes.string.def(""),
    empty: VueTypes.string.def("Insert a new title..."),
    icon: VueTypes.string.def(""),
    editable: VueTypes.bool.def(false),
  },
  computed: {
    text: {
      get() {
        return this.value;
      },
      set(val: string) {
        this.$emit("input", val);
      },
    },
    titleIcon() {
      return this.text.length ? this.icon : "cancel";
    },
  },
  methods: {
    toggleEdit() {
      this.edit = !this.edit;
    },
  },
});
</script>
<style scoped>
.edit {
  opacity: 0;
}
.title:hover .edit {
  opacity: 1;
}
.title {
  position: relative;
}
</style>
